<form [formGroup]="resourceForm" class="data-wrap" fxLayout="column">
    <div class="title" fxLayoutGap="5px" fxLayout="row wrap" fxLayoutAlign="start center">
        <mat-icon>category</mat-icon>
        <span i18n>Add competence</span>
    </div>

    <div fxLayout="column" fxLayoutGap="10px" fxLayoutAlign="start center">
        <div class="input-field-parent" fxLayout="column" fxLayoutGap="5px">
            <mat-form-field appearance="outline" floatLabel="never" class="w-100" fxFlex="grow">
                <input
                    matInput
                    [formControl]="searchCtrl"
                    placeholder="Search by ID, SKU, or title"
                    i18n-placeholder="@@search-competence-placeholder"
                />
                <button
                    *ngIf="selectedResource && selectedResource?.id"
                    mat-icon-button
                    class="cancel-contact"
                    matSuffix
                    (click)="onRemove()"
                >
                    <mat-icon>cancel</mat-icon>
                </button>
            </mat-form-field>
            <ng-container *ngIf="!!searchCtrl.value" [ngTemplateOutlet]="resourceChips"></ng-container>
        </div>
        <div class="input-field-parent" fxLayout="column" fxLayoutGap="5px">
            <div fxLayout="row wrap" fxLayoutAlign="start center">
                <span i18n>Title</span>
                <app-language-selector
                    formControlName="language_id"
                    class="icon-resource-builder"
                    fxFlex="0 0 auto"
                ></app-language-selector>
            </div>
            <mat-form-field appearance="outline" floatLabel="never" class="w-100" fxFlex="grow">
                <textarea
                    matInput
                    type="text"
                    formControlName="title"
                    placeholder="Pls set title"
                    i18n-placeholder
                    cdkTextareaAutosize
                    #autosize="cdkTextareaAutosize"
                    cdkAutosizeMinRows="1"
                    cdkAutosizeMaxRows="10"
                ></textarea>
            </mat-form-field>
        </div>

        <div fxLayoutGap="4px" fxLayout="column" class="w-100 input-field-parent deadline">
            <span i18n>Completion Date</span>
            <mat-form-field
                appearance="outline"
                floatLabel="never"
                class="w-100"
                fxFlex="grow"
                fxFlex="1 1 100%"
                fxFlex.lt-md="1 1 100%"
            >
                <mat-label i18n>Enter Completion date</mat-label>
                <input
                    matInput
                    [matDatepicker]="deadlineDatepicker"
                    (focus)="deadlineDatepicker.open()"
                    formControlName="done_at"
                />
                <mat-datepicker-toggle matIconSuffix [for]="deadlineDatepicker"></mat-datepicker-toggle>
                <mat-datepicker #deadlineDatepicker></mat-datepicker>
            </mat-form-field>
        </div>

        <div class="input-field-parent" fxLayout="column" fxLayoutGap="5px">
            <span i18n>Article code</span>
            <mat-form-field appearance="outline" floatLabel="never" class="w-100" fxFlex="grow">
                <textarea
                    matInput
                    type="text"
                    formControlName="article_code"
                    placeholder="Enter article code (SKU)"
                    i18n-placeholder
                    cdkTextareaAutosize
                    #autosize="cdkTextareaAutosize"
                    cdkAutosizeMinRows="1"
                    cdkAutosizeMaxRows="10"
                ></textarea>
            </mat-form-field>
        </div>

        <div class="input-field-parent" fxLayout="column" fxLayoutGap="5px">
            <span i18n>Description</span>
            <mat-form-field appearance="outline" floatLabel="never" class="w-100" fxFlex="grow">
                <textarea
                    matInput
                    type="text"
                    formControlName="description"
                    placeholder="Enter description"
                    i18n-placeholder
                    cdkTextareaAutosize
                    #autosize="cdkTextareaAutosize"
                    cdkAutosizeMinRows="3"
                    cdkAutosizeMaxRows="10"
                ></textarea>
            </mat-form-field>
        </div>
        <div fxLayoutGap="4px" fxLayout="column" class="w-100 input-field-parent k3-crm-tags">
            <span i18n>Tags</span>
            <app-tag-chip-select
                class="w-100"
                placeholder="Add Tag"
                [language_id]="resourceForm.value.language_id"
                i18n-placeholder
                formControlName="tag_ids"
            ></app-tag-chip-select>
        </div>

        <div class="input-field-parent" fxLayout="column" fxLayoutGap="5px">
            <span i18n>Note</span>
            <mat-form-field appearance="outline" floatLabel="never" class="w-100" fxFlex="grow">
                <textarea
                    matInput
                    type="text"
                    formControlName="note"
                    placeholder="Add note"
                    i18n-placeholder
                    cdkTextareaAutosize
                    #autosize="cdkTextareaAutosize"
                    cdkAutosizeMinRows="3"
                    cdkAutosizeMaxRows="10"
                ></textarea>
            </mat-form-field>
        </div>
    </div>
    <div class="action">
        <button fxFlex="0 0 auto" class="mobile-button negative" (click)="onClose.emit()" mat-button i18n>
            Cancel
        </button>
        <button
            [disabled]="!resourceForm.get('title')?.value"
            fxFlex="0 0 auto"
            class="mobile-button positive"
            (click)="submit()"
            mat-raised-button
            i18n
        >
            Submit
        </button>
    </div>
</form>
<ng-template #resourceChips>
    <mat-chip-list class="users-chip-select" *ngIf="!selectedResource">
        <mat-chip
            *ngFor="let resource of resourceSearch$ | async"
            (click)="onSelectResource(resource)"
            [selectable]="false"
            [removable]="false"
            color="primary"
        >
            <div fxLayout="row wrap" fxLayoutAlign="start center">
                <span>{{ resource.article_code }}</span>
                <span>({{ resource.title }})</span>
            </div>
        </mat-chip>
    </mat-chip-list>
</ng-template>
